package data.users

import apiclient.FormationClient
import apiclient.groups.restListGroupMembersForGroup
import apiclient.users.PublicUserProfile
import apiclient.users.restGetPublicUserProfile
import apiclient.util.simpleCache
import auth.ApiUserStore
import koin.withKoin
import kotlin.time.Duration.Companion.hours
import kotlinx.coroutines.CoroutineName
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.flow.Flow
import kotlinx.coroutines.flow.filterNotNull
import kotlinx.coroutines.flow.map
import kotlinx.coroutines.launch
import model.User
import model.getFirstGroupIdOrNull

class PublicUserProfileCache(val formationClient: FormationClient) {

    private val cache = simpleCache<String, PublicUserProfile>(capacity = 1000, maxAgeInMillis = 1.hours.inWholeMilliseconds)

    fun <T> getProfile(flow: Flow<T>, extractor: (T) -> String?): Flow<PublicUserProfile?> {
        return flow.map { element ->
            extractor(element)?.let { userId ->
                getProfile(userId)
            }
        }.filterNotNull()
    }

    fun fetchGroupMembers(user: User?) {
        withKoin {
            val apiUserStore: ApiUserStore = get()
            val currentUser = user ?: apiUserStore.current

            CoroutineScope(CoroutineName("fetch-users-for-userListStore")).launch {
                try {
                    val resp = currentUser.getFirstGroupIdOrNull()?.let { groupId ->
                        formationClient.restListGroupMembersForGroup(groupId = groupId)
                    }
                    resp?.fold(
                        { memberList ->
                            cache.putAll(memberList.mapNotNull { it.userProfile }.associateBy { it.userId })
//                            console.log("members",memberList.mapNotNull { it.userProfile })
                        },
                        {
                            console.log("Fetching group members failed", it.message)
                        },
                    )
                } catch (e: Exception) {
                    console.log("API call to fetch group members failed", e.message)
                }

            }
        }
    }

    suspend fun getProfile(id: String): PublicUserProfile? {
        return cache.getOrFetch(id) {
            formationClient.restGetPublicUserProfile(id).getOrNull()
        }
    }
}
